<template>
    <div class="rowitems">
        <div class="o-itemsBar" :class="{ open: menuOpen }">

            <div class="m-itemsBar__title">
                <p>{{ menuOpenNazov }}</p>
                <button class="a-itemsBar_close" @click="$emit('hideInventar')"></button>
            </div>

            <div v-if="kravicka.repozitar_kravicky" class="container">

                <template v-if="checkEmptyProducts || isMinihry">

                    <carousel class="m-itemBar__carousel" :perPageCustom="[[768, 5], [1024, 6], [1200,9]]" :navigationEnabled="true" navigation-next-label="" navigation-prev-label="">

                        <template v-if=" !isMinihry ">

                            <template
                                    v-for="item in kravicka.repozitar_kravicky.filter(checkCategory)"
                            >

                                <slide v-if="item.repozitar_kravicky_usage_type > 0" @slideclick="$emit('useInventarProdukt', kravicka.repozitar_kravicky.indexOf(item), item)">

                                    <div class="a-itemBar__body" :class="{'--empty' : item.repozitar_kravicky_usage_type == 0}">
                                        <img class="img-fluid" :src="'assets/img/produkty/'+ item.repozitar_kravicky_category +'/'+ item.herny_produkt_id.herny_produkt_img_inventar" alt="">
                                        <!-- pridá preloader ikonu -->
                                        <img v-if="item.herny_produkt_id.herny_produkt_povoleny == 'preloader.png'" class="img-fluid item-preloader" :src="'assets/img/produkty/preloader.png'" alt="">
                                        <p>{{ item.herny_produkt_id.herny_produkt_meno }}</p>
                                        <span v-if="item.repozitar_kravicky_usage_type < 999" class="count">{{ item.repozitar_kravicky_usage_type }}</span>
                                        <span v-else class="count"><span style="font-size:24px">&infin;</span></span>
                                    </div>

                                </slide>

                            </template>

                        </template>

                        <!-- Minihry -->
                        <template v-else>

                            <slide @slideclick="$router.push({ name: 'pexeso-landing', params: { kravicka_id: $route.params.kravicka_id } })">
                                <div class="a-itemBar__body">
                                    <img class="img-fluid" :src="'assets/img/pexeso/pexeso.svg'" alt="">
                                    <p>Pexeso</p>
                                </div>
                            </slide>

                            <slide @slideclick="$router.push({ name: 'slider-landing', params: { kravicka_id: $route.params.kravicka_id } })">
                                <div class="a-itemBar__body">
                                    <img class="img-fluid" :src="'assets/img/puzzle/puzzle.svg'" alt="">
                                    <p>Skladanie obrázka</p>
                                </div>
                            </slide>

                        </template>

                    </carousel>

                </template>

                <template v-else>

                    <div class="row align-items-center justify-content-center">
                        <div class="col-md-6 text-center pt-4">
                            <p class="colorWhite">Momentálne tu nemáš žiadnu vecičku pre kravičku. Kúp jej niečo v obchode.</p>
                            <b-button class="btn --primary" @click="$router.push({ name: 'obchod', params: { kategoria: menuOpenKategoria, kravicka_id: kravicka.id } })">Do obchodu</b-button>
                        </div>
                    </div>

                </template>

            </div>

            <div class="m-carouselNav"></div>

        </div>
    </div>
</template>



<script>
    export default {
        props: [
            'menuOpen',
            'menuOpenKategoria',
            'menuOpenNazov',
            'kravicka'
        ],
        computed: {
            isMinihry() {
                return this.menuOpenKategoria === 'games'
            },
            checkEmptyProducts() {
                if ( this.kravicka.repozitar_kravicky.filter(this.checkCategory).length < 1 ) {
                    return false
                }
                else {
                    var item
                    var allEmpty = true
                    for (item of this.kravicka.repozitar_kravicky.filter(this.checkCategory) ) {
                        if ( item.repozitar_kravicky_usage_type > 0 ) {
                            allEmpty = false
                        }
                    }
                    return !allEmpty
                }
            }
        },
        methods: {
            checkCategory(value) {
                return value.repozitar_kravicky_category === this.menuOpenKategoria
            },
        }
    }
</script>